export default __webpack_public_path__ + "static/media/Snd3.fef1225f.mp3";